import React, { useMemo } from "react";

import { useTranslation } from "react-i18next";
import { Accordion } from "./styles";
import { AccountRole, useMeQuery } from "../../graphql";
import Link from "../CustomLink";
import GroupLink from "../GroupLink";


export interface IPath {
  id: number;
  to: string;
  label: any;
}

export interface ILinkPaths {
  key: number;
  label: any;
  to?: string;
  role?: AccountRole[];
  subpaths?: IPath[];
}

interface INavigatorProps {
  config: ILinkPaths[];
}

const filterByRole = (role: AccountRole) => (item: ILinkPaths) => {
    if (!item.role) {
        return true;
    }

    if (item.role.length === 0) {
        return true;
    }

    return item.role.includes(role);
};

const Navigator: React.FC<INavigatorProps> = ({ config }) => {
    const { t } = useTranslation();
    const { data } = useMeQuery();

    // data.me.role === AccountRole.Admin

    const byRole = filterByRole(data?.me?.role);
    return (
        <Accordion
            reduceMotion={ true }
            allowToggle
            defaultIndex={ [0, 1, 2, 3, 4, 5] }
        >
            { config.filter(byRole).map(({ key, label, to, subpaths }) => {
                if (subpaths) {
                    return <GroupLink key={ key } label={ label } subpaths={ subpaths } />;
                }
                return <Link key={ key } label={ t(label) } href={ to! } />;
            }) }
        </Accordion>
    );
};

export default Navigator;
